import React from 'react';
import './InfoBadge.css';

const InfoBadge = ({ message, link }) => {
  return (
    <div className="info-badge">
      <span className="info-icon">ℹ️</span>
      <span className="info-text">{message}</span>
      {link && (
        <a href={link.url} className="info-link">
          {link.text}
        </a>
      )}
    </div>
  );
};

export default InfoBadge;
